import S from 's-js';

import { VesselServiceSettings } from 'data/models/VesselServiceSettings';
import { VesselSearchResultData } from 'data/models/VesselSearchResult';
import { VesselServiceActive } from 'server/enums/VesselServiceActive';
import { ExternalVesselSearchType } from 'server/enums/ExternalVesselSearchType';

import { IAjax } from 'lib/Ajax';
import { Entrypoints } from 'core/app/entrypoints';

export interface ExternalVesselSearchParams {
    onSelect : (v : VesselSearchResultData) => void;
    onManualEntry : () => void;
    onDismiss : () => void;
}

export type ExternalVesselSearch = ReturnType<typeof ExternalVesselSearch>;
export function ExternalVesselSearch(
    settings : VesselServiceSettings, 
    ajax: IAjax, 
    entrypoints: Entrypoints, 
    {
        onSelect,
        onManualEntry,
        onDismiss
    } : ExternalVesselSearchParams
) {
    const
        SearchResults = S.data<VesselSearchResultData[] | null>(null),
        Searching = S.value(false),
        CanSearchCallSign = () => settings.LloydServiceActive() === VesselServiceActive.Active || settings.PSixServiceActive() === VesselServiceActive.Active,
        CanSearchImo = () => settings.LloydServiceActive() === VesselServiceActive.Active || settings.MarineTrafficServiceActive() === VesselServiceActive.Active,
        CanSearchMmsi = () => settings.LloydServiceActive() === VesselServiceActive.Active || settings.MarineTrafficServiceActive() === VesselServiceActive.Active,
        CanSearch = () => (CanSearchImo() || CanSearchMmsi() || CanSearchCallSign()),
        SearchType = S.data(S.sample(() =>
            CanSearchImo() ? ExternalVesselSearchType.IMO :
            CanSearchMmsi() ? ExternalVesselSearchType.MMSI :
            CanSearchCallSign() ? ExternalVesselSearchType.CallSign :
            ExternalVesselSearchType.IMO
        )),
        HasPrevCache = S.data(false),
        Query = S.data(""),
        Placeholder = () => {
            var fields = [] as string[];
            if (CanSearchImo()) fields.push("IMO");
            if (CanSearchCallSign()) fields.push("Call Sign");
            if (CanSearchMmsi()) fields.push("MMSID");
            return `Select ${fields.join(" or ")} and enter the value`;
        };

    return {
        Query,
        Placeholder,
        CanSearchImo,
        CanSearchMmsi,
        CanSearchCallSign,
        CanSearch,
        SearchType,
        Search,
        SearchResults,
        Select: onSelect,
        ManualEnter: onManualEntry,
        Cancel: onDismiss,
        Searching,
        HasPrevCache
    };

    function Search() {
        SearchResults(null);
        Searching(true);
        var url = entrypoints.PortCallVesselServiceSearch({ Type: SearchType(), Query: Query() });
        ajax.Url(url).Get()
            .then(SearchResults) 
            .finally(() =>
                Searching(false)
            );
    }
}



// WEBPACK FOOTER //
// ./apps/portcall/externalvesselsearch/model.ts